import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { checkGameDetailIsFetched } from '@client/feature/game-detail/application/routes/check-game-detail-is-fetched.route-guard';
import { GameDetailRouteName } from '@client/feature/game-detail/domain/route/game-detail.route-name';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';

const GameDetailAppModule = () => import('@client/feature/game-detail/game-detail.app-module');
const GameDetailLayout = () => import('@client/feature/game-detail/application/layout/GameDetailLayout.vue');
const GameDetailPage = () => import('@client/feature/game-detail/application/page/GameDetailPage.vue');
const GameQuestsPage = () => import('@client/feature/game-quest-management/application/page/GameQuestsPage.vue');
const GameEntitiesPage = () => import('@client/feature/game-entities-management/application/page/GameEntitiesPage.vue');
const GamePlayersListPage = () => import('@client/feature/game-detail/application/page/GamePlayersListPage.vue');
const GameStatisticsPage = () => import('@client/feature/game-detail/application/page/GameStatisticsPage.vue');

export class GameDetailModuleRoutes extends ModuleRoutes<GameDetailRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: 'games/:gameKind/:gameId',
        component: GameDetailLayout,
        beforeEnter: [loadLazyAppModuleGuard(GameDetailAppModule, container)],
        children: [
          {
            path: '',
            name: GameDetailRouteName.Detail,
            component: GameDetailPage,
            beforeEnter: checkGameDetailIsFetched,
          },
          {
            path: 'quests',
            name: GameDetailRouteName.Quests,
            component: GameQuestsPage,
            beforeEnter: [checkGameDetailIsFetched],
          },
          {
            path: 'players',
            name: GameDetailRouteName.PlayersList,
            component: GamePlayersListPage,
            beforeEnter: checkGameDetailIsFetched,
          },
          {
            path: 'entities',
            name: GameDetailRouteName.Entities,
            component: GameEntitiesPage,
            beforeEnter: checkGameDetailIsFetched,
          },
          {
            path: 'statistics',
            name: GameDetailRouteName.Statistics,
            component: GameStatisticsPage,
            beforeEnter: checkGameDetailIsFetched,
          },
        ],
      },
    ];

    super(routes);
  }
}
